var render = function render(){var _vm=this,_c=_vm._self._c;return _c('insight',{attrs:{"insight":_vm.insight,"image-name":'blue-flower.svg',"button-text":"לחשב תזרים מחדש","button-action":_vm.buttonAction},scopedSlots:_vm._u([{key:"insight-text",fn:function(){return [_c('div',{staticClass:"ri-title"},[_vm._v("\n      לאור המצב, הנה 5 צעדים שיעזרו לך להתאים את התזרים למציאות החדשה\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }